"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledFooter = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
//
// properties
//
const config_1 = require("assets/styles/config");
exports.StyledFooter = styled_components_1.default.div `
  align-items: center;
  border-top: 1px solid ${config_1.colors.pavement};
  display: flex;
  height: 75px;
  justify-content: center;
`;
